//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      options: null,
      append: {}
    };
  },
  computed: {
    values: function values() {
      // Depends on whether the field is single or multiple
      if (this.$type.isArray(this.fieldModel)) {
        return this.fieldModel.length > 0 ? this.fieldModel : this.emptyValue;
      } else {
        return [this.fieldModel];
      }

      return this.emptyValue;
    },
    // To avoid empty param error
    emptyValue: function emptyValue() {
      return [null];
    }
  },
  methods: {
    $ready: function $ready() {
      var spec = this.spec;
      var options = spec.options;

      if (Utils.type.isArray(options)) {
        // It can be really confusing if the options are not strings (e.g. value-text pair)
        this.options = options.map(function (i) {
          return Utils.type.isString(i) ? i : console.warn("Option needs to be a string", i);
        });
      }

      this.append = spec.append || {};
    }
  }
};